module.exports = function addUnit (item, unit) {
  if (typeof item === 'string') {
    return item
  }
  return item + unit
}



//////////////////
// WEBPACK FOOTER
// ./~/create-keyframe-animation/lib/add-unit.js
// module id = 1752
// module chunks = 0